document.addEventListener("DOMContentLoaded", () => {
  const addToCartBtn = document.querySelector('[data-add-to-cart]');
  if (!addToCartBtn) return;

  // Inicialmente desactivado
  addToCartBtn.disabled = true;

  const toggleButtonAndInput = () => {
    const zipFlag = localStorage.getItem("zipFlag");

    if (zipFlag === "true") {
      // Mostrar y habilitar botón, eliminar textbox si existe
      addToCartBtn.style.display = "";
      addToCartBtn.disabled = false;
      const existingInput = document.querySelector('#zip-container');
      if (existingInput) existingInput.remove();
    } else {
      // Ocultar botón y mostrar textbox
      addToCartBtn.style.display = "none";
      addToCartBtn.disabled = true;

      if (!document.querySelector('#zip-input-replacement')) {
        const container = document.createElement("div");
        container.id = "zip-container";
        // container.style.marginBottom = "1rem";

        // Crear mensaje
        // const message = document.createElement("p");
        // message.id = "zip-input-message";
        // message.textContent = "Ayudamos a encontrar los productos disponibles cerca de ti";
        // message.style.fontSize = "0.95rem";
        // message.style.marginBottom = "0.5rem";
        // message.style.color = "#444";

        // Crear input
        const input = document.createElement("input");
        input.type = "text";
        input.id = "zip-input-replacement";
        input.style.margin="0rem";
        input.placeholder = "Introduce tu código postal aqui";
        input.style.backgroundColor = "#eac5ff";
        // input.style.backgroundColor = "#78cab5";
        // input.classList.add("input--replacement"); // opcional para estilos
        // input.style.padding = "0.5rem";
        input.style.width = "100%";
        input.style.borderRadius = "20px";
        input.style.border = "1px solid #ccc";

        // container.appendChild(message);
        container.appendChild(input);
        addToCartBtn.parentNode.insertBefore(container, addToCartBtn);

        input.addEventListener("change", () => {
          const zip = input.value.trim();
          
          // 🔹 Aquí defines tu validación
          if (zip.length === 5 && /^\d+$/.test(zip)) {
            localStorage.setItem("zipFlag", "true");
            localStorage.setItem("userZipCode", zip);

            // const matchedLocationId = mapPostalCodeToLocationId(zip);
            // window.inventoryInfo?.api?.selectLocation(matchedLocationId);
              location.reload();
            toggleButtonAndInput();
          } else {
            alert("Por favor, ingresa un codigo postal");
            localStorage.setItem("zipFlag", "false");
          }
        });

      }
    }
  };

  // Inicial
  toggleButtonAndInput();

  // Observar cambios en localStorage desde otras pestañas
  window.addEventListener("storage", (event) => {
    if (event.key === "zipFlag") {
      toggleButtonAndInput();
    }
  });
});
